<template>
  <AppRadioGroup inline>
    <AppRadio :value="false" :label="$tt('no')" />
    <AppRadio :value="true" :label="$tt('yes')" />
  </AppRadioGroup>
</template>